import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';

export default styled(LoadingOutlined)`
  font-size: 40px;
  margin: -20px !important;
`;
